/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

import type { Identifier } from '@/ts/entities/base/identifier.ts'

import { useAuthStore } from '@/stores/auth.ts'

export function usePermissions() {
  const authStore = useAuthStore()
  function canAccessRoomReservation(deptId: number | Identifier) {
    const userPermissions = authStore.user.permissions.find((perm) => perm.department_id === deptId.valueOf())
    return userPermissions ? Object.values(userPermissions.permissions.reservations).some((b) => b === true) : false
  }
  function canAccessManage(deptId: number | Identifier) {
    const userPermissions = authStore.user.permissions.find((perm) => perm.department_id === deptId.valueOf())
    return userPermissions
      ? Object.values(userPermissions.permissions.courses).some((b) => b === true) ||
          Object.values(userPermissions.permissions.people).some((b) => b === true) ||
          Object.values(userPermissions.permissions.modules).some((b) => b === true) ||
          Object.values(userPermissions.permissions.groups).some((b) => b === true) ||
          Object.values(userPermissions.permissions.periods).some((b) => b === true)
      : false
  }

  return {
    canAccessRoomReservation,
    canAccessManage,
  }
}
